// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  beliefId: __t.u64().primaryKey().name("belief_id"),
  versonaId: __t.u64().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  kind: __t.string(),
  subjectId: __t.u64().name("subject_id"),
  subjectKey: __t.string().name("subject_key"),
  text: __t.string(),
  weight: __t.i32(),
  confidence: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
